export default __webpack_public_path__ + "static/media/kpmg.e1b0e089.png";